import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import AdSchoolInfoManager from "../../../../../services/system/school-info/ad-school-info-manager";
import AddressController from "../../../../../services/system/address/address-controller";
import AddressManager from "../../../../../components/Address";
import { useSearchParams } from "react-router-dom";
import {getSchoolId} from "../../../../../utils/authority";
import Utils from "../../../../../utils/utils";
function withParams(Component) {
    return (props) => <Component {...props} params={useSearchParams()} navigate={useNavigate()} />;
}
class EditSchool extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            principalRes: '',

            adSchoolUuid: '',
            adSchoolFullname: "",
            adSchoolUsername: '',

            name: "",
            abbreviationName: '',
            address: '',
            dateOfFoundation: '',
            provinceId:'',
            districtId:'',
            wardId:'',
            des: "",
            fax: "",
            trainType: "DAN_LAP",
            website: "",
            regionId: 1,
            governingBody: "",
            isUpdated: false
        };
    }
    UNSAFE_componentWillMount() {
        this.setState({showLoading: true}, () => {
            const [searchparams] = this.props.params;
            let schoolId = searchparams.get("id");
            // let schoolId = getSchoolId()
            AdSchoolInfoManager.detail(schoolId, res => {
                if (res.success){
                    let data = res.data
                    this.setState({
                        id: data.id,
                        name: data.name,
                        nameEn: data.nameEn,
                        abbreviationName: data.abbreviationName,
                        mail: data.mail,
                        phone: data.phone,
                        dateOfFoundation: data.dateOfFoundation,

                        address: data.address,
                        provinceId: data.provinceCode,
                        districtId: data.districtCode,
                        wardId: data.wardCode,

                        principalRes: data.principalRes,

                        adSchoolFullname: data.adminRes === null?"":data.adminRes.fullName,
                        adSchoolUsername: data.adminRes === null?"":data.adminRes.username,
                        adSchoolUuid: data.adminRes === null?"":data.adminRes.uuid,

                        fax: data.fax,
                        trainType: data.trainType,
                        website: data.website,
                        regionId: data.regionId,
                        governingBody: data.governingBody
                    })
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        })
    }
    renderRegion = () => {
        let _region = JSON.parse(localStorage.getItem("region")) ? JSON.parse(localStorage.getItem("region")) : '';
        if (_region.length > 1){
            return _region.map((item, index) => <option
                value={item.id}>{item.name}</option>)
        }
    };
    getListRegion(){
        let payloadWard = {
            "pageNumber": 0,
            "pageSize": 1000,
            "sort": "name desc"
        }
        AddressController.getAllRegion(payloadWard, res => {
            if (res.success) {
                localStorage.setItem("region", JSON.stringify(res.data.content))
            }
        });
    }

    onEdit = () => {
        let {id, adSchoolFullname, adSchoolUuid, adSchoolUsername, abbreviationName, address, dateOfFoundation, districtId, fax, governingBody, mail, name, nameEn, phone, provinceId, regionId, trainType, wardId, website} = this.state;
        if (name === "" || name.length < 6){
            toast.error("Tên trường phải lớn hơn 6 ký tự");
        }else if (abbreviationName === "" || abbreviationName.length < 3){
            toast.error("Tên viết tắt trường phải lớn hơn 3 ký tự");
        }else {
            let payload = {
                id: id,
                adminReq: {
                    fullName: adSchoolFullname,
                    username: adSchoolUsername,
                    uuid: adSchoolUuid,
                },
                abbreviationName: abbreviationName,
                address: address,
                dateOfFoundation: dateOfFoundation,
                districtCode: districtId,
                fax: fax,
                governingBody: governingBody,
                mail: mail,
                name: name,
                phone: phone,
                provinceCode: provinceId,
                regionId: parseInt(regionId),
                trainType: trainType,
                website: website,
                wardCode: wardId,
                nameEn: name,
            }
            AdSchoolInfoManager.edit(payload, res => {
                if (res.success){
                    toast.success("Sửa trường thành công!")
                    // setTimeout(() => {
                    //     this.props.navigate('/ad-sas-school/quan-ly-truong-hoc');
                    // }, 200)
                } else {
                    toast.error("Đã xảy ra lỗi: " + res.message)
                }
            })
        }
    }
    render() {
        let {address, provinceId, districtId, wardId}  = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-school-management" parentClass="system-school-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Sửa thông tin trường"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>CẬP NHẬT THÔNG TIN TRƯỜNG</h2>
                                        <div className="row">
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên trường(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên viết tắt(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.abbreviationName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            abbreviationName: Utils.filterNormalCharacter(event.target.value).trim()
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại hình đào tạo(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.trainType}
                                                    onChange={(e) => {
                                                        this.state.trainType = e.target.value;
                                                        this.setState({
                                                            trainType: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="CONG_LAP">Công lập</option>
                                                    <option value="DAN_LAP">Tư thục</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Hệ(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.schoolType}
                                                    onChange={(e) => {
                                                        this.state.schoolType = e.target.value;
                                                        this.setState({
                                                            schoolType: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="MAM_NON">Mầm non</option>
                                                    <option value="TIEU_HOC">Tiểu học</option>
                                                    <option value="TRUNG_HOC">Trung học</option>
                                                    <option value="PHO_THONG">Phổ thông</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại hình đào tạo(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.trainType}
                                                    onChange={(e) => {
                                                        this.state.trainType = e.target.value;
                                                        this.setState({
                                                            trainType: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="CONG_LAP">Công lập</option>
                                                    <option value="DAN_LAP">Tư thục</option>
                                                </select>
                                            </div>
                                            {/*<div className="col-md-6 col-xs-12  d-flex mb-2">*/}
                                            {/*    <label className="col-4 label-item pl-0">Loại trường(<span  style={{color: "red",}}>*</span>)</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.schoolType}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.schoolType = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                schoolType: e.target.value*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value="1">Trường bình thường</option>*/}
                                            {/*        <option value="2">Trường chuyên</option>*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày thành lập(<span  style={{color: "red",}}>*</span>)</label>
                                                <DatePicker
                                                    locale="vi"
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.dateOfFoundation === '' ? null : new Date(this.state.dateOfFoundation)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    dateOfFoundation: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD")
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            {/*<div className="col-md-6 col-xs-12  d-flex mb-2">*/}
                                            {/*    <label className="col-4 label-item pl-0">Khóa học</label>*/}
                                            {/*    <input*/}
                                            {/*        maxLength={255} type="text"*/}
                                            {/*        className="form-control shadow-none"*/}
                                            {/*        value={this.state.year}*/}
                                            {/*        onChange={(event) => {*/}
                                            {/*            this.setState({*/}
                                            {/*                year: event.target.value*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.phone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.mail}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            mail: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            {/*<div className="col-md-6 col-xs-12  d-flex mb-2">*/}
                                            {/*    <label className="col-4 label-item pl-0">Fax</label>*/}
                                            {/*    <input*/}
                                            {/*        maxLength={255} type="text"*/}
                                            {/*        className="form-control shadow-none"*/}
                                            {/*        value={this.state.fax}*/}
                                            {/*        onChange={(event) => {*/}
                                            {/*            this.setState({*/}
                                            {/*                fax: event.target.value*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Website</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.website}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            website: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 p-2 mb-2 bg-gradient"><b>THÔNG TIN ĐỊA CHỈ</b>  <hr/>
                                            </div>

                                            <AddressManager
                                                addressUsually={address}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(address, wardId, districtId, provinceId) => this.setState({address: address, districtId: districtId, provinceId: provinceId, wardId: wardId})}
                                            />
                                            {/*<div className="col-md-6 col-xs-12  d-flex mb-2">*/}
                                            {/*    <label className="col-4 label-item pl-0">Khu vực(<span  style={{color: "red",}}>*</span>)</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.regionId}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.regionId = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                regionId: e.target.value*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value={0}>Chọn khu vực</option>*/}
                                            {/*        {this.renderRegion()}*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-12 p-2 mb-2 bg-gradient"><b>THÔNG TIN HIỆU TRƯỞNG</b><hr/>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên hiệu trưởng</label>
                                                <label className="col-4 label-item pl-0">{this.state.principalRes?.fullName}</label>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại</label>
                                                <label className="col-4 label-item pl-0">{this.state.principalRes?.phone}</label>
                                            </div>
                                            <div className="col-12 p-2 mb-2 bg-gradient"><b>THÔNG TIN ADMIN TRƯỜNG</b><hr/>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên đăng nhập</label>
                                                <label className="label-item pl-0">{this.state.adSchoolUsername}</label>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên hiển thị</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.adSchoolFullname}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            adSchoolFullname: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="col-md-2 col-xs-2 ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == "" || this.state.abbreviationName == null}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="col-md-2 col-xs-2 ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-truong-hoc"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default withParams(EditSchool)
